export default __webpack_public_path__ + "static/media/news27.beca03eb.jpg";